module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am30-459c67856c2696dd67ef3defd221519a.jpg";